// Tira do texto o que parece segredo antes de ele entrar num reporte: valor de parâmetro de
// query sensível, trecho opaco longo de caminho e o fragmento da URL (`#...`).

const REDACTED = '[removido]';

/** Nomes de parâmetro cujo valor nunca sai do navegador. */
const SENSITIVE_KEY = /token|code|secret|key|session|otp|password|senha|auth|signature|sig/i;

/** Segmento de caminho que é um token opaco: 24+ caracteres sem separador, com dígito. */
const OPAQUE_SEGMENT = /^(?=.*\d)[A-Za-z0-9_-]{24,}$/;

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `ids públicos` (`txn_...`, 30 caracteres) passam: o prefixo mostra que não é token. */
const PUBLIC_ID = /^[a-z]{2,4}_[0-9a-z]{26}$/;

function redactSegment(segment: string): string {
  if (UUID.test(segment) || PUBLIC_ID.test(segment)) {
    return segment;
  }
  return OPAQUE_SEGMENT.test(segment) ? ':token' : segment;
}

/**
 * Rota do painel segura para ir no reporte: caminho + query, sem hash, com valor sensível
 * e segmentos opacos trocados.
 */
export function sanitizeRoute(pathname: string, search: string): string {
  const path = pathname.split('/').map(redactSegment).join('/');
  const params = new URLSearchParams(search);
  const kept: string[] = [];
  for (const [key, value] of params) {
    kept.push(
      `${encodeURIComponent(key)}=${SENSITIVE_KEY.test(key) ? REDACTED : encodeURIComponent(value)}`,
    );
  }
  return kept.length === 0 ? path : `${path}?${kept.join('&')}`;
}

/** `chave=valor` com chave sensível, e token tipo JWT, dentro de texto livre. */
export function redactSecrets(text: string): string {
  return text
    .replace(
      /([?&;\s"']?)([\w-]*(?:token|code|secret|key|session|otp|password|senha|auth|signature)[\w-]*)=([^&\s"']+)/gi,
      `$1$2=${REDACTED}`,
    )
    .replace(/\beyJ[\w-]{8,}\.[\w-]{8,}\.[\w-]{8,}\b/g, REDACTED)
    .replace(/\bBearer\s+[\w.~+/-]+=*/gi, `Bearer ${REDACTED}`);
}
